/* eslint-disable no-param-reassign */
const _ = require('lib/underscore')
const Banner = require('module/banner/banner')
const log = require('log').create('dialog', 'banner') // eslint-disable-line

/* convenience method for showing a banner using the existing Dialog.banner API */

function banner(msg, options = {}) {
    if (_.isString(msg)) {
        if (msg === _.escape(msg)) {
            options.text = msg
        } else {
            options.html = msg
        }
    } else if (_.isObject(msg)) {
        options = msg
    } else {
        throw new Error('Dialog.banner requires (text, {options}), (html, {options}), or ({options}).')
    }
    return new Banner(options)
}

module.exports = banner
